import React from "react";
import Arpg from "../component/arpg/arpg";

const ArpgPage = () => {
  return (
    <div className="arpg-page">
      <Arpg />
    </div>
  );
};

export default ArpgPage;
